<template>
  <header data-component-name="HeaderLanding">
    <div class="wrapper">
      <AppLogo />

      <NuxtLink :to="localePathWithSlash('/')">
        <SvgIcon name="best-storage-for-veeam" fill="#212529" />
      </NuxtLink>
    </div>
  </header>
</template>

<script setup lang="ts">
// components
import AppLogo from '~/components/redesign/AppLogo.vue';

// composable
import useLocalePathWithSlash from '~/composables/useLocalePathWithSlash';

const localePathWithSlash = useLocalePathWithSlash();
</script>

<style scoped lang="scss">
@import '$/mixins/size';
@import '$/mixins/flex';
@import '$/mixins/media';
@import '$/variables/shadows';

header[data-component-name='HeaderLanding'] {
  box-shadow: map-get($shadows, 'Elevation 1');

  .wrapper {
    padding: 0.375rem 2rem;
    @include wrapper(80rem);
    @include flex-center-sb;

    @include tablet {
      padding: 0.375rem 2rem;
    }

    @include mobile {
      padding: 0.5rem 1rem;
    }

    [data-component-name='AppLogo'] {
      @include fixed-width(9.18rem);
      @include fixed-height(2.97rem);

      @include tablet {
        @include fixed-width(8.8rem);
        @include fixed-height(2.97rem);
      }

      @include mobile {
        @include fixed-width(7.49rem);
        @include fixed-height(2.43rem);
      }
    }

    a:last-of-type {
      display: inline-flex;

      svg {
        @include fixed-width(10.5875rem);
        @include fixed-height(3.3125rem);

        @include tablet {
          @include fixed-width(10.5875rem);
          @include fixed-height(3.3125rem);
        }

        @include mobile {
          @include fixed-width(7.9906rem);
          @include fixed-height(2.5rem);
        }
      }
    }
  }
}
</style>
